import ApiService from './api'

const BASE_URL = '/hr/shifts'

export const hrShiftService = {
  // Get all shifts
  getAllShifts: async () => {
    try {
      const response = await ApiService.get(BASE_URL)
      return response
    } catch (error) {
      console.error('Error fetching shifts:', error)
      throw error
    }
  },

  // Create a new shift
  createShift: async (shiftData) => {
    try {
      const response = await ApiService.post(BASE_URL, shiftData)
      return response
    } catch (error) {
      console.error('Error creating shift:', error)
      throw error
    }
  },

  // Update a shift
  updateShift: async (shiftId, shiftData) => {
    try {
      const response = await ApiService.patch(`${BASE_URL}/${shiftId}`, shiftData)
      return response
    } catch (error) {
      console.error('Error updating shift:', error)
      throw error
    }
  },

  // Delete a shift
  deleteShift: async (shiftId) => {
    try {
      const response = await ApiService.delete(`${BASE_URL}/${shiftId}`)
      return response
    } catch (error) {
      console.error('Error deleting shift:', error)
      throw error
    }
  },

  // Get shift by ID
  getShiftById: async (shiftId) => {
    try {
      const response = await ApiService.get(`${BASE_URL}/${shiftId}`)
      return response
    } catch (error) {
      console.error('Error fetching shift by ID:', error)
      throw error
    }
  }
}

export default hrShiftService
